module EEX.McEc.Controls.CertificateDialog {

    import CreatePrivateKeyCommand = McEc.Commands.CreatePrivateKeyCommand;

    // ReSharper disable once InconsistentNaming
    export interface CreatePrivateKeyAttribute extends CertificateDialogBaseAttribute {
    }

    export class CreatePrivateKeyModel extends CertificateDialogBaseModel<CreatePrivateKeyAttribute> {

        private createPrivateKeyCommand: CreatePrivateKeyCommand;

        constructor(model: CertificateDialogModel, processStep: number, createPrivateKeyCommand: CreatePrivateKeyCommand) {
            super(model, processStep);

            this.createPrivateKeyCommand = createPrivateKeyCommand;
        }

        public create() {
            this.createPrivateKeyCommand.createPrivateKey(store => this.onCreatedPrivateKey(store)); 
        } 

        private onCreatedPrivateKey(store: Pki.Store) {
            this.model.set({ store: store });
            this.canContinue();
        }

        public isCreated() {
            return this.model.get().store !== null
                && this.model.get().store !== undefined;
        }
    }

    // ReSharper disable once InconsistentNaming
    export interface CreatePrivateKeyOptions extends CertificateDialogBaseOptions {
    }

    export class CreatePrivateKeyView extends CertificateDialogBaseView<CreatePrivateKeyModel> {
        model: CreatePrivateKeyModel;

        private containers: {
            loader: HTMLElement, 
        }

        private elements: {
            info: JQuery,
            finishedInfo: JQuery,
            loader: JQuery,
        }

        constructor(model: CreatePrivateKeyModel, target: HTMLElement, options?: CreatePrivateKeyOptions) {
            super(model,
                target,
                McEc.Templates.CertificateDialog_CreatePrivateKey,
                AppKitchen.OptionsHelper.merge(options,
                    {
                        title: McEc.Strings.CertificateDialog_CreatePrivateKey_Title
                    }));

            this.model.on("change:canContinue",
                () => {
                    //this.showContent(this.model.isCanContinue());
                });
        }

        render() {
            super.render();
            this.setContainers();
            this.setElements();
            this.createLoader();
            this.showContent(this.model.isCanContinue());

            if (!this.model.isCreated()) {
                this.model.create();
            }
            return this;
        }

        private setContainers(): void {
            this.containers = {
                loader: this.$el.find(".create-private-key-loader-container")[0]
            }
        } 

        private setElements(): void {
            this.elements = {
                info: this.$el.find(".create-private-key-gernerate-info"),
                finishedInfo: this.$el.find(".create-private-key-fnished-gernerate-info"),
                loader: this.$el.find(".create-private-key-loader-container")
            }
        } 

        private createLoader(): void {
            AppKitchen.UIHelper.renderLoader(this.containers.loader, {type: "circle"});
        }

        private showContent(canContinue: boolean): void {
            this.toggleContentVisibility(this.elements.finishedInfo, canContinue);
            this.toggleContentVisibility(this.elements.loader, !canContinue);
            this.toggleContentVisibility(this.elements.info, !canContinue);
        }
    }
}
